<template>
  <v-container :class="{'pa-0': $vuetify.breakpoint.xs}">
    <qrScannerForm :qrReader="qrReader" />
    <v-data-iterator
      :items="filteredEquipment"
      :pagination.sync="pagination"
      :rows-per-page-items="rowsPerPageItems"
      disable-initial-sort
      content-tag="v-layout"
      wrap
    >
      <v-layout slot="header" column>
        <v-toolbar
          class="mb-2"
          color="indigo darken-5"
          dark
          flat
          :extended="!$vuetify.breakpoint.mdAndUp"
        >
          <v-tooltip bottom>
            <template slot="activator">
              <button @click="showfilter = !showfilter">
                <v-icon>filter_list</v-icon>
              </button>
            </template>
            <span>{{showfilter ? $t('equipment.workRequests.hideFilter') : $t('equipment.workRequests.showFilter')}}</span>
          </v-tooltip>
          <v-toolbar-title>{{ $t(onlyMy ? 'navigation.myEquipment' : 'navigation.allEquipment') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <template v-slot:extension>
            <v-tabs v-model="equipmentMode" color="indigo darken-5" slider-color="yellow">
              <v-tab v-for="(tabItem,i) in tabItems" :key="i">{{tabItem.name}}</v-tab>
            </v-tabs>
          </template>
          <v-flex>
            <v-text-field
              v-if="this.$vuetify.breakpoint.mdAndUp"
              class="mt-0 pt-0"
              @blur="refresh()"
              v-on:keyup.enter="refresh()"
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <v-menu full-width v-else offset-y top :close-on-content-click="false">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon class="ma-0">
                  <v-icon>search</v-icon>
                </v-btn>
              </template>
              <v-flex pa-2 white>
                <v-text-field
                  v-model="search"
                  @blur="refresh()"
                  v-on:keyup.enter="refresh()"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
            </v-menu>
          </v-flex>
          <v-btn @click="qrReader=!qrReader; topFunction()" icon>
            <v-icon class="pr-4 pl-4">fa-qrcode</v-icon>
          </v-btn>
        </v-toolbar>

        <v-layout row slot="extension" wrap v-if="showfilter">
          <v-flex v-for="header in headers" :key="header.text" xs12 md4 sm6>
            <div v-if="filters.hasOwnProperty(header.value)">
              <v-combobox
                :label="header.text"
                flat
                multiple
                clearable
                :items="columnValueList(header.value)"
                v-model="filters[header.value]"
                color="indigo darken-5"
                small-chips
                deletable-chips
                dense
                :prepend-icon="header.icon"
              ></v-combobox>
            </div>
          </v-flex>
        </v-layout>
      </v-layout>

      <v-flex slot="item" slot-scope="props" pa-2 xs12 sm6 md4>
        <EquipmentCard :equipment="props.item" />
      </v-flex>
    </v-data-iterator>
  </v-container>
</template>

<script>
import EquipmentCard from '../components/EquipmentCard'
import EamSearch from '../components/EamSearch'
import qrScannerForm from './qrScannerForm'

import { mapActions } from 'vuex'

export default {
  name: 'AllEquipment',
  components: {
    EquipmentCard,
    EamSearch,
    qrScannerForm
  },
  props: {
    onlyMy: Boolean
  },
  mounted() {
    this.refresh()
  },
  data: vm => {
    return {
      qrReader: false,
      rowsPerPageItems: [12, 36, 108],
      pagination: {
        rowsPerPage: 12
      },
      filters: {
        TypeName: [],
        Category: [],
        Status: [],
        ResponsibleName: [],
        ObjectName: [],
        DepartmentName: []
      },
      equipmentModeVal: null
    }
  },

  methods: {
    ...mapActions(['updateAllEquipment']),
    columnValueList(val) {
      return this.allEquipment.map(e => e[val]).sort()
    },

    topFunction() {
      if (this.qrReader) {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      }
    },
    refresh() {
      // this.updateAllEquipment({
      //   onlyMy: this.isAuthenticated && this.equipmentMode == 1,
      //   onlyFav: this.isAuthenticated && this.equipmentMode == 2
      // })
      if(this.isAuthenticated) {
        this.updateAllEquipment({
          onlyMy: this.isAuthenticated && this.equipmentMode == 1,
          onlyFav: this.isAuthenticated && this.equipmentMode == 2,
          search: this.search && this.search.length ? this.search : null,
        })
      }
    }
  },
  computed: {
    showfilter: {
      get: function() {
        return this.$store.state.base.showfilter
      },
      set: function(newValue) {
        this.$store.state.base.showfilter = newValue
      }
    },
    tabItemsDefault() {
      return [
        { name: this.$i18n.t("navigation.all"), value: "all" },
        { name: this.$i18n.t("navigation.my1"), value: "my" },
        { name: this.$i18n.t("navigation.favorite1"), value: "fav" }
      ];
    },
    headers() {
      return [
        {
          text: this.$t('equipment.allEquipment.typeName'),
          value: 'TypeName',
          icon: 'title'
        },
        {
          text: this.$t('equipment.allEquipment.category'),
          value: 'Category',
          icon: 'view_carousel'
        },
        {
          text: this.$t('equipment.allEquipment.status'),
          value: 'Status',
          icon: 'speaker_notes'
        },
        {
          text: this.$t('equipment.allEquipment.responsibleName'),
          value: 'ResponsibleName',
          icon: 'person'
        },
        {
          text: this.$t('equipment.allEquipment.objectName'),
          value: 'ObjectName',
          icon: 'home'
        },
        {
          text: this.$t('equipment.allEquipment.departmentName'),
          value: 'DepartmentName',
          icon: 'domain'
        }
      ]
    },
    search: {
      get: function() {
        return this.$store.state.base.search
      },
      set: function(newValue) {
        this.$store.state.base.search = newValue
      }
    },
    equipmentMode: {
      get: function() {
        if (this.equipmentModeVal === null || !this.isAuthenticated) {
          const parsedFilterMode = parseInt(
            localStorage.getItem('eamEquipmentMode')
          )
          this.equipmentModeVal = parsedFilterMode || 1
        }
        return this.equipmentModeVal
      },
      set: function(newValue) {
        this.equipmentModeVal = newValue
        localStorage.setItem('eamEquipmentMode', newValue.toString())
        this.refresh()
      }
    },
    tabItems() {
      const isAuth = this.isAuthenticated
      return this.tabItemsDefault.filter(i => isAuth || i.value === 'all')
    },
    allEquipment() {
      return this.$store.getters.allEquipment
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    filteredEquipment() {
      return this.allEquipment.filter(e => {
        return Object.keys(this.filters).every(f => {
          return this.filters[f].length < 1 || this.filters[f].includes(e[f])
        })
      })
    },
    currentLocale() {
      return this.$store.getters.currentLocale
    }
  },
  watch: {
    isAuthenticated() {
      this.refresh()
    },
    currentLocale() {
      this.refresh()
    }
  }
}
</script>

<style>
</style>
